// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const AlertTriangleIcon = /* @__PURE__ */ createIcon(
  'alert-triangle',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M11.188 2.17a2 2 0 0 1 1.427-.075l.197.076.144.072c.32.183.538.45.696.673.184.26.38.601.598.977L22.475 18.1c.218.377.418.718.551 1.008.132.284.274.666.229 1.102a2 2 0 0 1-.814 1.41c-.354.258-.756.325-1.068.354-.317.029-.713.028-1.148.028H3.775c-.436 0-.832 0-1.15-.028-.31-.029-.713-.096-1.067-.354a2 2 0 0 1-.813-1.41c-.045-.436.097-.818.229-1.102.133-.29.332-.632.55-1.008L9.75 3.893c.217-.376.414-.718.598-.977.18-.255.44-.567.84-.745m.791 1.902a13 13 0 0 0-.499.823L3.256 19.102c-.238.41-.381.66-.467.845l-.013.03.033.006c.203.018.49.019.965.019h16.45c.476 0 .762 0 .966-.02q.018-.001.033-.004l-.012-.03a12 12 0 0 0-.467-.846L12.52 4.895c-.238-.41-.382-.656-.5-.823L12 4.047zm.03 12.43a1 1 0 0 1 0 2H12a1 1 0 1 1 0-2zm-1.009-3v-4a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0',
      },
    ],
  ]
);
